export class PenDesignTypeDto {
  public static ApiUrl = 'api/pen-design-type';

  Id: number;
  Type: PenDesignTypeEnum;
  Name: string;
  NameEn: string;
  NameEs: string;
}

export enum PenDesignTypeEnum {
  OtherDesign = 0,
  ExtremeHD500 = 1,
}
